import React from "react";
import MenuBlock from "./MenuBlock";
import { MenuBlockWithoutRouter } from "./MenuBlockWithoutRouter";

const MenuBlockSwitch = (props) => {
    return props.withoutRouter ? (
        <MenuBlockWithoutRouter {...props} />
    ) : (
        <MenuBlock {...props} />
    );
};

export default MenuBlockSwitch;



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/MenuBlock/index.js